import { URLAPI } from "../../shared/const";
import { defaultIdDisplayed } from "./../../shared/data";
import { Injectable, SimpleChanges } from "@angular/core";
import { Http } from "@angular/http";

import {
  APIService,
  Logger,
  LoaderService,
  ToasterService,
  defaultValueType,
  defaultMoneyCO2,
  defaultIndicator,
  defaultEnergyService,
  defaultEnergyServiceBdg,
  defaultEnergyType,
  defaultNetworksInd,
  defaultPerimeter,
  defaultVehicleFuels,
  defaultVehicleTypes,
  defaultDashboardType,
  defaultTimeLine,
  defaultActionCategory,
  defaultSiaAssignment,
  defaultEnergeticAgent,
  defaultGhsScopesSectors,
  defaultGhgScopes,
  defaultGhgEmissionSectors,
  buttonsValueType,
  buttonsIndicator,
  buttonsMoneySavedCO2,
  buttonsIndicatorsVehicles,
  buttonsEnergyService,
  buttonsEnergyServiceForBdg,
  buttonsEnergyType,
  buttonsNetworksIndService,
  buttonsPerimeterService,
  buttonsVehicleFuelService,
  buttonsVehicleTypeService,
  buttonsActionCategory,
  buttonsSiaAssignment,
  buttonsEnergeticAgent,
  buttonsScopesSectors,
  buttonsGhgScopes,
  buttonsEmissionSectors,
  idChartMix,
  idChartMixStratData,
  idChartRenewable,
  idChartRenewableStratData,
  idChartLocal,
  idChartLocalStratData,
  idChartEvolution,
  idChartEvolutionStratData,
  idChartRenewableBarChart,
  idChartRenewableBarChartEnAbs,
  idChartRenewableBarChartEnPct,
  idChartRenewableBarChartElec,
  idChartRenewableBarChartHeat,
  idChartRenewableBarChartMobility,
  idChartLocalBarChart,
  idChartMixBarChart,
  idChartActual,
  idChartStrategy,
  idChartStrategyElec,
  idChartStrategyHeat,
  idChartStrategyHeatAbs,
  idChartStrategyHeatEnAbs,
  idChartStrategyHeatRefMesObj,
  idChartNetworksGeneral,
  idChartStrategyBuilding,
  idChartStrategyBuildingRefMesObj,
  idChartStrategyMobility,
  idChartVechiculeFuelNb,
  idChartVechiculeFuelNbOnlyAmount,
  idChartVechiculeEnergyGhgBar,
  idChartVechiculeEnergyAbs,
  idChartVechiculeTypeNb,
  idChartRenHeatDoughnut,
  idChartRenElecDoughnut,
  idChartRenMobilityDoughnut,
  idChartElecProductConsumption,
  idChartRenEnergyProd,
  idChartActions,
  idChartSubsidies,
  idChartS2000W,
  idGhgBalance,
  idGhgBalanceOnlySectors,
  idGhgBalancePubAdministration,
  idAvoidGhgBalancePubAdministration,
  idAvoidGhgBalancePubAdministrationLineCumulated,
  idChartWaterConsumption,
  idChartPublicBdg,
  idChartHeaterSubstitution,
  idChartElecProd,
  idChartElecProdWithRatioPotWithoutInj,
  idChartElecProdWithRatioPotWithoutInjAbs,
  idChartPvTarget,
  idPublicConsumptionByBuildingType,
  idPublicConsumptionByEnergeticAgent,
  idMinergieNew,
  idMinergieRenovation,
  idMinergieStack,
  idCyclingPaths,
  idParkingSpaces,
  idElectricityHouseholdConsumption,
  idRenovationPercentageTarget,
  idLocalElectricityTarget,
  idPvInstallationTarget,
  idPvInstallationTargetDetailed,
  idSubsidiesCount,
  INITIAL_COMPARISON
} from "app/shared";
import { City } from "app/features/filter-options/city";
import { DataInteraction, Year } from "app/shared/data-interaction";
import { OnChanges } from "@angular/core/src/metadata/lifecycle_hooks";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Button, promise } from "selenium-webdriver";

@Injectable()
export class FilterOptionService extends APIService {
  private cities;
  private dataFilters: BehaviorSubject<DataInteraction> = new BehaviorSubject<
    DataInteraction
  >(null);
  private years: BehaviorSubject<Year[]> = new BehaviorSubject<Year[]>(null); // = [{ "name": "2018", "id": 1 }, { "name": "2019", "id": 2 }, { "name": "2020", "id": 3 }, { "name": "2050", "id": 18 }]
  private year: Year; //  = this.years[0];
  private charts: string[] = [
    idChartEvolution,
    idChartEvolutionStratData,
    idChartRenewableBarChart,
    idChartRenewableBarChartEnAbs,
    idChartRenewableBarChartEnPct,
    idChartRenewableBarChartElec,
    idChartRenewableBarChartHeat,
    idChartRenewableBarChartMobility,
    idChartLocalBarChart,
    idChartMixBarChart,
    idChartActual,
    idChartMix,
    idChartMixStratData,
    idChartRenewable,
    idChartRenewableStratData,
    idChartLocal,
    idChartLocalStratData,
    idChartStrategy,
    idChartStrategyElec,
    idChartStrategyHeat,
    idChartStrategyHeatAbs,
  idChartStrategyHeatEnAbs,
    idChartStrategyHeatRefMesObj,
    idChartNetworksGeneral,
    idChartStrategyBuilding,
    idChartStrategyBuildingRefMesObj,
    idChartStrategyMobility,
    idChartElecProductConsumption,
    idChartActions,
    idChartSubsidies,
    idChartS2000W,
    idGhgBalance,
    idGhgBalanceOnlySectors,
    idGhgBalancePubAdministration,
    idAvoidGhgBalancePubAdministration,
    idAvoidGhgBalancePubAdministrationLineCumulated,
    idChartWaterConsumption,
    idChartPublicBdg,
    idMinergieNew,
    idMinergieRenovation,
    idMinergieStack,
    idCyclingPaths,
    idParkingSpaces,
    idLocalElectricityTarget,
    idPvInstallationTarget,
    idPvInstallationTargetDetailed,
    idSubsidiesCount
  ];
  private buttonsValues = buttonsValueType;
  private buttonsIndicators = buttonsIndicator;
  private buttonsIndicatorsVehicles = buttonsIndicatorsVehicles;
  private buttonsEnergy = buttonsEnergyService;
  private buttonsEnergyServiceForBdg = buttonsEnergyServiceForBdg;
  private buttonsEnergyType = buttonsEnergyType;
  private energy_services: string[] = defaultEnergyService;
  private energy_services_bdg: string[] = [];
  private energy_type: string[] = [];
  private buttonsMoneySavedCO2 = buttonsMoneySavedCO2;
  private money_co2_saved = defaultMoneyCO2;
  private buttonsNetworksInd = buttonsNetworksIndService;
  private networksInd: string = defaultNetworksInd;
  private buttonsPerimeter = buttonsPerimeterService;
  private perimeter: string = defaultPerimeter;
  private buttonsVehicleFuel = buttonsVehicleFuelService;
  private vehicleFuel: string[] = [];
  private buttonsVehicleType = buttonsVehicleTypeService;
  private vehicleType: string[] = [];
  private buttonsActionCategory = buttonsActionCategory;
  private actionCategory: string = defaultActionCategory;
  private buttonsSiaAssignment = buttonsSiaAssignment;
  private siaAssignment: string[] = [];
  private buttonsEnergeticAgent = buttonsEnergeticAgent;
  private energeticAgent: string[] = [];
  private buttonsScopesSectors = buttonsScopesSectors;
  private ghgScopesSectors: string = defaultGhsScopesSectors;
  private buttonsGhgScopes = buttonsGhgScopes;
  private ghgScope: string[] = defaultGhgScopes;
  private buttonsEmissionSectors = buttonsEmissionSectors;
  private emissionSector: string[] = defaultGhgEmissionSectors;
  private initialComparison = INITIAL_COMPARISON;
  private value_type = defaultValueType;
  private indicator = defaultIndicator;
  
  constructor(
    protected http: Http,
    protected logger: Logger,
    protected loaderService: LoaderService,
    protected toasterService: ToasterService
  ) {
    super(http, logger, loaderService, toasterService);
  }

  getDataFilters(): BehaviorSubject<DataInteraction> {
    return this.dataFilters;
  }

  // SETTER
  selectToCompare(city) {
    this.setMainCharts();
    this.setFilters();
  }
  setYear(year, update_global_data = true) {
    this.year = year;
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  }
  setValueType = (id, update_global_data = true) => {
    if (this.value_type != id) {
      this.buttonsValues.forEach(button => {
        button.selected = button.id == id;
      });
      this.value_type = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setIndicator = (id, update_global_data = true) => {
    if (this.indicator != id) {
      this.buttonsIndicators.forEach(button => {
        button.selected = button.id == id;
      });
      this.indicator = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setMoneyOrCO2 = (id, update_global_data = true) =>{
    if (this.money_co2_saved != id) {
      this.buttonsMoneySavedCO2.forEach(button => {
        button.selected = button.id == id;
      });
      this.money_co2_saved = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  }
  setIndicatorVehicles = (id, update_global_data = true) => {
    if (this.indicator != id) {
      this.buttonsIndicatorsVehicles.forEach(button => {
        button.selected = button.id == id;
      });
      this.indicator = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  /* setTimelineValue(timeline) {
        this.dataFilters.value.timeline = timeline;
        this.setFilters();
    } */
  setEnergyService = (button, update_global_data = true) => {
    if (!button.selected) {
      this.energy_services.push(button.id);
    } else {
      const index = this.energy_services.indexOf(button.id);
      if (index > -1) {
        this.energy_services.splice(index, 1);
      }
    }
    button.selected = !button.selected;
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setEnergyServiceBdg = (button, update_global_data = true) => {
    if (!button.selected) {
      this.energy_services_bdg.push(button.id);
      button.selected = true;
    } else {
      const index = this.energy_services_bdg.indexOf(button.id);
      if (index > -1) {
        this.energy_services_bdg.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setEnergyType = (button, update_global_data = true) => {
    if (!button.selected) {
      this.energy_type.push(button.id);
      button.selected = true;
    } else {
      const index = this.energy_type.indexOf(button.id);
      if (index > -1) {
        this.energy_type.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setPerimeter = (id, update_global_data = true) => {
    if (this.perimeter != id) {
      this.buttonsPerimeter.forEach(button => {
        button.selected = button.id == id;
      });
      this.perimeter = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setNetworksInd = (id, update_global_data = true) => {
    if (this.networksInd != id) {
      this.buttonsNetworksInd.forEach(button => {
        button.selected = button.id == id;
      });
      this.networksInd = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setVehicleFuels = (button, update_global_data = true) => {
    if (!button.selected) {
      this.vehicleFuel.push(button.id);
      button.selected = true;
    } else {
      const index = this.vehicleFuel.indexOf(button.id);
      if (index > -1) {
        this.vehicleFuel.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setVehicleTypes = (button, update_global_data = true) => {
    if (!button.selected) {
      this.vehicleType.push(button.id);
      button.selected = true;
    } else {
      const index = this.vehicleType.indexOf(button.id);
      if (index > -1) {
        this.vehicleType.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setActionCategory = (id, update_global_data = true) => {
    if (this.actionCategory != id) {
      this.buttonsActionCategory.forEach(button => {
        button.selected = button.id == id;
      });
      this.actionCategory = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setSiaAssignment = (button, update_global_data = true) => {
    if (!button.selected) {
      this.siaAssignment.push(button.id);
      button.selected = true;
    } else {
      const index = this.siaAssignment.indexOf(button.id);
      if (index > -1) {
        this.siaAssignment.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setEnergeticAgent = (button, update_global_data = true) => {
    if (!button.selected) {
      this.energeticAgent.push(button.id);
      button.selected = true;
    } else {
      const index = this.energeticAgent.indexOf(button.id);
      if (index > -1) {
        this.energeticAgent.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  };
  setGhgScopesSectors = (id, update_global_data = true) => {
    if (this.ghgScopesSectors != id) {
      this.buttonsScopesSectors.forEach(button => {
        button.selected = button.id == id;
      });
      this.ghgScopesSectors = id;
      if (update_global_data) {
        this.setAllCharts();
        this.setFilters();
      }
    }
  };
  setGhgScopes = (button, update_global_data = true) => {
    if (!button.selected) {
      this.ghgScope.push(button.id);
      button.selected = true;
    } else {
      const index = this.ghgScope.indexOf(button.id);
      if (index > -1) {
        this.ghgScope.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  }

  setGhgEmissionSectors = (button, update_global_data = true) => {
    if (!button.selected) {
      this.emissionSector.push(button.id);
      button.selected = true;
    } else {
      const index = this.emissionSector.indexOf(button.id);
      if (index > -1) {
        this.emissionSector.splice(index, 1);
        button.selected = false;
      }
    }
    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
    return this.emissionSector;
  }

  setMainCharts() {
    this.charts = [idChartEvolution, idChartActual];
  }
  setAllCharts() {
    this.charts = [
      idChartEvolution,
      idChartEvolutionStratData,
      idChartRenewableBarChart,
      idChartRenewableBarChartEnAbs,
      idChartRenewableBarChartEnPct,
      idChartRenewableBarChartElec,
      idChartRenewableBarChartHeat,
      idChartRenewableBarChartMobility,
      idChartLocalBarChart,
      idChartMixBarChart,
      idChartActual,
      idChartMix,
      idChartMixStratData,
      idChartRenewable,
      idChartRenewableStratData,
      idChartLocal,
      idChartLocalStratData,
      idChartStrategy,
      idChartStrategyElec,
      idChartStrategyHeat,
      idChartStrategyHeatAbs,
      idChartStrategyHeatEnAbs,
      idChartStrategyHeatRefMesObj,
      idChartNetworksGeneral,
      idChartStrategyBuilding,
      idChartStrategyBuildingRefMesObj,
      idChartStrategyMobility,
      idChartVechiculeFuelNb,
      idChartVechiculeFuelNbOnlyAmount,
      idChartVechiculeEnergyGhgBar,
      idChartVechiculeEnergyAbs,
      idChartVechiculeTypeNb,
      idChartRenHeatDoughnut,
      idChartRenElecDoughnut,
      idChartRenMobilityDoughnut,
      idChartElecProductConsumption,
      idChartRenEnergyProd,
      idChartActions,
      idChartSubsidies,
      idChartS2000W,
      idGhgBalance,
      idGhgBalanceOnlySectors,
      idGhgBalancePubAdministration,
      idAvoidGhgBalancePubAdministration,
      idAvoidGhgBalancePubAdministrationLineCumulated,
      idChartWaterConsumption,
      idChartPublicBdg,
      idChartHeaterSubstitution,
      idChartElecProd,
      idChartElecProdWithRatioPotWithoutInj,
      idChartElecProdWithRatioPotWithoutInjAbs,
      idChartPvTarget,
      idPublicConsumptionByBuildingType,
      idPublicConsumptionByEnergeticAgent,
      idMinergieNew,
      idMinergieRenovation,
      idMinergieStack,
      idCyclingPaths,
      idParkingSpaces,
      idElectricityHouseholdConsumption,
      idRenovationPercentageTarget
    ];
  }
  setFilters() {
    this.dataFilters.next({
      dashboard_type: defaultDashboardType,
      value_type: this.value_type,
      indicator: this.indicator,
      energy_service: this.energy_services,
      energy_service_bdg: this.energy_services_bdg,
      energy_type: this.energy_type,
      cities: this.cities,
      charts: this.charts,
      year: this.year,
      money_co2_saved: this.money_co2_saved,
      networksInd: this.networksInd,
      perimeter: this.perimeter,
      vehicleFuel: this.vehicleFuel,
      vehicleType: this.vehicleType,
      actionCategory: this.actionCategory,
      siaAssignment: this.siaAssignment,
      energeticAgent: this.energeticAgent,
      ghgScopesSectors: this.ghgScopesSectors,
      ghgScope: this.ghgScope,
      emissionSector: this.emissionSector
    });
  }

  setDefaultFilterValues(desiredFilterValues, update_global_data = true) {
    // make sure there are default values provided for the filters
    if (desiredFilterValues) {
      // for each filter set the default values
      const filterNames = Object.keys(desiredFilterValues);
      filterNames.forEach(filterName => {
        const currentFilterValues = desiredFilterValues[filterName];
        // make sure there are default values provided for this filter
        if (currentFilterValues) {
          // set the value for each button of the current filter
          const buttonNames = Object.keys(currentFilterValues);
          buttonNames.forEach(buttonName => {
            this.setButton(
              filterName,
              buttonName,
              currentFilterValues[buttonName],
              false
            );
          });
        }
      });
    }

    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  }

  /* 
  Set specific button to the desired value
  If the button is a radio button, it is only set if the desired value is true.
  Nothing happens if the desired value is false, because it is not possible to infer which button should be selected.
   */
  setButton(filterName, buttonId, buttonValue, update_global_data = true) {
    enum FilterType {
      Xor, // radio button
      Or // checklist
    }

    let buttonSetter;
    let buttonsGetter;
    let filterType: FilterType;

    // Process button differently according to filter
    switch (filterName) {
      case "compareCitiesFromRegion":
        //TODO
        break;
      case "yearSelector":
        //TODO
        break;

      case "typeOfValue":
        filterType = FilterType.Xor;
        buttonSetter = this.setValueType;
        break;

      case "moneySavedCO2":
        filterType = FilterType.Xor;
        buttonSetter = this.setMoneyOrCO2;
        break;

      case "typeOfIndicator":
        filterType = FilterType.Xor;
        buttonSetter = this.setIndicator;
        break;
      
      case "typeOfIndicatorVehicles":
        filterType = FilterType.Xor;
        buttonSetter = this.setIndicatorVehicles;
        break;

      case "energyService":
        filterType = FilterType.Or;
        buttonSetter = this.setEnergyService;
        buttonsGetter = this.getButtonsEnergyService;
        break;

      case "energyServiceForBuildings":
        filterType = FilterType.Or;
        buttonSetter = this.setEnergyServiceBdg;
        buttonsGetter = this.getButtonsEnergyServiceForBdg;
        break;

      case "energyType":
        filterType = FilterType.Or;
        buttonSetter = this.setEnergyType;
        buttonsGetter = this.getButtonsEnergyType;
        break;

      case "perimeter":
        filterType = FilterType.Xor;
        buttonSetter = this.setPerimeter;
        break;

      case "vehicleFuels":
        filterType = FilterType.Or;
        buttonSetter = this.setVehicleFuels;
        buttonsGetter = this.getButtonsVehicleFuel;
        break;

      case "vehicleTypes":
        filterType = FilterType.Or;
        buttonSetter = this.setVehicleTypes;
        buttonsGetter = this.getButtonsVehicleType;
        break;

      case "typeOfNetworksInd":
        filterType = FilterType.Xor;
        buttonSetter = this.setNetworksInd;
        break;

      case "actionCategory":
        filterType = FilterType.Xor;
        buttonSetter = this.setActionCategory;
        break;

      case "siaAssignment":
        filterType = FilterType.Or;
        buttonSetter = this.setSiaAssignment;
        buttonsGetter = this.getButtonsSiaAssignment;
        break;

      case "energeticAgent":
        filterType = FilterType.Or;
        buttonSetter = this.setEnergeticAgent;
        buttonsGetter = this.getButtonsEnergeticAgent;
        break;

      case "ghgScopesSectors":
        buttonSetter = this.setGhgScopesSectors;
        buttonsGetter= this.getButtonsScopesSectors;
        break;

      case "ghgScope":
        filterType = FilterType.Or;
        buttonSetter = this.setGhgScopes;
        buttonsGetter = this.getButtonsGhgScopes;
        break;

      case "emissionSector":
        filterType = FilterType.Or;
        buttonSetter = this.setGhgEmissionSectors;
        buttonsGetter = this.getButtonsGhgEmissionSectors;
        break;
        
    }

    if (filterType == FilterType.Xor) {
      // Set only if desired value is true
      if (buttonValue) {
        buttonSetter(buttonId, false);
      }
    } else if (filterType == FilterType.Or) {
      const buttonToChange = this.getButtonById(buttonsGetter(), buttonId);
      // Change button only if it exists
      // And only if selected state does not correspond to the desired value
      if (buttonToChange && buttonToChange.selected != buttonValue) {
        buttonSetter(buttonToChange, false);
      }
    }

    if (update_global_data) {
      this.setAllCharts();
      this.setFilters();
    }
  }

  // GETTER
  getButtonById(buttonsList, buttonId) {
    const buttonsIds = buttonsList.map(button => {
      return button.id;
    });
    const buttonIndex = buttonsIds.indexOf(buttonId);
    return buttonsList[buttonIndex];
  }

  getButtonsValueType() {
    return this.buttonsValues;
  }
  getButtonsIndicator() {
    return this.buttonsIndicators;
  }
  getButtonsMoneyOrCO2(){
    return this.buttonsMoneySavedCO2;
  }
  getButtonsIndicatorVehicles(){
    return this.buttonsIndicatorsVehicles;
  }
  getButtonsEnergyService = () => {
    return this.buttonsEnergy;
  };
  getButtonsEnergyServiceForBdg = () => {
    return this.buttonsEnergyServiceForBdg;
  };
  getButtonsEnergyType = () => {
    return this.buttonsEnergyType;
  };
  getButtonsPerimeter() {
    return this.buttonsPerimeter;
  }
  getButtonsNetworksInd() {
    return this.buttonsNetworksInd;
  }
  getButtonsVehicleFuel = () => {
    return this.buttonsVehicleFuel;
  };
  getButtonsVehicleType = () => {
    return this.buttonsVehicleType;
  };
  getButtonsActionCategory() {
    return this.buttonsActionCategory;
  }
  getButtonsSiaAssignment = () => {
    return this.buttonsSiaAssignment;
  };
  getButtonsEnergeticAgent = () => {
    return this.buttonsEnergeticAgent;
  };
  getButtonsScopesSectors = () => {
    return this.buttonsScopesSectors;
  };
  getButtonsGhgScopes = () => {
    return this.buttonsGhgScopes;
  };
  getButtonsGhgEmissionSectors = () => {
    return this.buttonsEmissionSectors;
  };

  getYearsFromApi(kpiNames?: string[], cityId?: number) {
    this.logger.log("FilterOptionService/getYears");
    let url = URLAPI + "/year/?";

    // add query parameters if any
    // todo: maybe there are methods to build queries?
    if (kpiNames && kpiNames.length > 0) {
      url += "kpis=" + kpiNames.join();
    }
    if (cityId) {
      url += "&city_id=" + cityId;
    }

    return this.GET(url).toPromise();
  }

  updateYears(
    kpiNames?: string[],
    cityId?: number,
    desiredYears?: number[],
    descending: boolean = false
  ) {
    this.getYearsFromApi(kpiNames, cityId).then(data => {
      let years = data["results"];
      // Filter out years which are not selectable because of future projections or objectives
      years = years.filter(
        year => parseInt(year["name"]) < 2030 // todo: remove hardcoded
      );
      // Filter out year that are not desired if values are provided
      if (desiredYears && desiredYears.length > 0) {
        years = years.filter(year =>
          desiredYears.includes(parseInt(year["name"]))
        );
      }
      if (descending) {
        years.reverse();
      }

      this.years.next(years);
    });
  }

  getYears(): BehaviorSubject<Year[]> {
    return this.years;
  }

  getDataFilter(): DataInteraction {
    return this.dataFilters.value;
  }

  getCities() {
    this.logger.log("FilterOptionService/getCities");
    return this.getCityFromAPI().toPromise();
  }
  getCity(id): City {
    return this.cities.filter(x => x.objectId === +id)[0];
  }
  getCityFromAPI() {
    this.cities = [];
    const urlCity = URLAPI + "/city/";
    return super.GET(urlCity);
  }

  getRegion() {
    this.logger.log("FilterOptionService/getRegion");
    return this.getRegionFromAPI().toPromise();
  }
  getRegionFromAPI() {
    this.cities = [];
    const urlCity = URLAPI + "/region/";
    return super.GET(urlCity);
  }

  resetCitySelected() {
    this.cities.map(city => {
      if(city.selected == true && this.initialComparison == "True"){
        city.toCompare = true;
      }
      city.selected = false;
    });
  }
  dataFiltersNext() {
    this.dataFilters.next(this.dataFilters.value);
  }
  setCities(res) {
    res.map(city => {
      let selected = false;
      if (city.objectId === defaultIdDisplayed) {
        selected = true;
      }
      let checkedCities = false;
      if (this.initialComparison === "True"){
        checkedCities = true;
      }
      this.cities.push({
        name: city.name,
        objectId: city.objectId,
        selected: selected,
        toCompare: checkedCities,
        translate: `CITIES.${city.name}`
      });
    });
    return this.cities;
  }
}
